import CloseRounded from "@mui/icons-material/CloseRounded";
import { Box, Divider, IconButton, Stack, Typography } from "@mui/material";

import { useTranslation } from "@/translations";

import { ClientDropZone } from "./components/client-dropzone/ClientDropZone";
import { ClientSelfUploads } from "./components/client-self-uploads/ClientSelfUploads";
import { CounselorDropZone } from "./components/my-dropzone/CounselorDropZone";

const PANEL_WIDTH = 346;

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function DropZonePanel({ isOpen, onClose }: Props) {
  const { t } = useTranslation();

  return (
    <Box
      aria-hidden={!isOpen}
      sx={{
        width: isOpen ? PANEL_WIDTH : 0,
        minWidth: 0,
        p: 2,
        flexShrink: 0,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        borderRight: "1px solid",
        borderColor: isOpen ? "divider" : "transparent",
        transition: (theme) =>
          theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: isOpen ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen,
          }),
      }}
    >
      <Stack sx={{ width: "100%", height: "100%" }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ flexShrink: 0 }}>
          <Typography variant="body1" fontWeight={"bold"}>
            {t("dropzone.title")}
          </Typography>
          <IconButton onClick={onClose} aria-label={t("common.close")} size="small">
            <CloseRounded />
          </IconButton>
        </Stack>
        <Divider sx={{ my: 1.5 }} />

        <Stack sx={{ overflow: "auto", flexGrow: 1 }} gap={1}>
          <CounselorDropZone />
          <ClientDropZone />
          <ClientSelfUploads />
        </Stack>
      </Stack>
    </Box>
  );
}
